import { Component, Prop } from 'vue-property-decorator';
import BaseVue from '@/helper/BaseVue';

@Component
export default class CommonPageTitle extends BaseVue {
  @Prop() name!: string;
  @Prop() title!: string;

  public handleBack() {
    this.$router.back();
  }
}
